import type { ImageModalProps } from "@/components/common/Modal/ImageModal";
import type { SignInModalProps } from "@/components/common/Modal/SignInModal/SignInModal";
import { create } from "zustand";

export type ModalCommonProps = {
  allowBackdropClose?: boolean;
  showCloseButton?: boolean;
};

export type ModalType = "sign-in" | "image" | "add-friend";

type AddFriendModalProps = ModalCommonProps & {
  apiType: "Chat" | "Live";
  targetId: number;
};

type ModalProps = {
  "sign-in": SignInModalProps;
  image: ImageModalProps;
  "add-friend": AddFriendModalProps;
};

type State =
  | {
      isOpen: false;
      type: null;
      data: null;
    }
  | {
      isOpen: true;
      type: ModalType;
      data?: ModalProps[ModalType];
    };

const initialState: State = {
  isOpen: false,
  type: null,
  data: null,
};

const useModalStore = create<State>(() => initialState);

const modalCommonPropsByType: Record<ModalType, ModalCommonProps> = {
  "sign-in": {
    allowBackdropClose: false,
    showCloseButton: true,
  },
  image: {
    allowBackdropClose: true,
    showCloseButton: false,
  },
  "add-friend": {
    allowBackdropClose: false,
    showCloseButton: false,
  },
};

export const openModal = (type: ModalType, data?: ModalProps[ModalType]) =>
  useModalStore.setState({
    isOpen: true,
    type,
    data: {
      ...data,
      ...modalCommonPropsByType[type],
    },
  });

export const closeModal = () => useModalStore.setState(initialState);

export default useModalStore;
